export default __webpack_public_path__ + "static/media/thumbnail1.179c0bc0.jpg";